const useHead = {
  methods: {
    /**
     * Sets meta data
     * @param {Object} storyblok - storyblok component that contains head info
     * @returns
     */
    useHead(storyblok = {}) {
      return {
        htmlAttrs: {
          lang: storyblok.full_slug?.includes('zh-cn') ? 'zh-cn' : 'en',
        },
        title: storyblok.content?.title,
        titleTemplate: '%s | IWBI',
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: storyblok.content?.description,
          },
          {
            name: 'robots',
            content: 'noindex',
          },
          // Twitter
          {
            name: 'twitter:card',
            content: storyblok.content?.twitter_card,
          },
          { name: 'twitter:site', content: '@wellcertified' },
          {
            name: 'twitter:creator',
            content: storyblok.content?.twitter_author || '@wellcertified',
          },
          {
            name: 'twitter:title',
            content: storyblok.content?.twitter_title,
          },
          {
            name: 'twitter:description',
            content: storyblok.content?.twitter_description,
          },
          {
            name: 'twitter:image',
            content: storyblok.content?.twitter_image,
          },
          // OG
          {
            hid: 'og:title',
            property: 'og:title',
            content: storyblok.content?.og_title,
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: storyblok.content?.og_description,
          },
          {
            hid: 'og:type',
            property: 'og:type',
            content: 'website',
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content:
              storyblok.content?.og_image ||
              'https://wearewell.com/img/copernico-p_kicqcom4s-unsplash.png',
          },
          {
            hid: 'og:locale',
            property: 'og:locale',
            content: 'en_US',
          },
          {
            hid: 'og:url',
            property: 'og:url',
            content: storyblok.full_slug,
          },
        ],
        links: [
          {
            rel: 'canonical',
            href:
              'https://www.wellcertified.com/' +
              (storyblok.full_slug !== 'home' ? storyblok.full_slug : ''),
          },
        ],
      }
    },
  },
}

export { useHead }
